// english

export default {
  system_dashboard: '系统面板',
  system_dashboard_user: '用户统计',
  system_dashboard_user_total: '总用户数',
  system_dashboard_user_online: '在线用户数',
  system_dashboard_user_disabled: '禁用用户数',
  system_dashboard_customer: '客户统计',
  system_dashboard_customer_total: '总的客户数',
  system_dashboard_device_model: '设备模型统计',
  system_dashboard_device_model_total: '总的设备模型数',
  system_dashboard_info: '系统信息',
  system_dashboard_info_mysql: 'Mysql db',
  system_dashboard_info_mqtt: 'MQTT',
  system_dashboard_info_nps: 'NPS',
  system_dashboard_info_redis: 'Redis',
  system_dashboard_info_frontend: '前端',
  system_dashboard_info_backend: '后台',

  system_dashboard_system_events: '最近系统事件',
  system_dashboard_system_events_types: {
    0: 'Disconnect',
    1: 'Minor Alarm',
    2: 'Alarm',
    3: 'Unavailable.',
  },
  system_dashboard_system_events_table_sn: 'SN',
  system_dashboard_system_events_table_status: '状态',
  system_dashboard_system_events_table_type: '类型',
  system_dashboard_system_events_table_start_time: '开始时间',
  system_dashboard_system_events_table_end_time: '结束时间',
  system_dashboard_recent_user: '最近添加用户',

  system_dashboard_recent_customer: '最近添加客户',
  system_dashboard_recent_device_model: '最近添加设备模型',
  system_dashboard_table_open: '打开中',
  system_dashboard_table_ended: '已结束',
};
